<template>
  <CommonLayout header="customerHeader" footer="customerFooter">
    <CustomerMeetingLayout :type="this.consts.meetingType.customer">
      <BOverlay :show="overlayShow" rounded="sm">
        <div class="base-color mh-550 shadow">
          <div class="p-2">
            <img :src="hearingData('imagePath')" class="w-100">
            <div class="col-sm-12 text-center pt-4">
              <h2>{{hearingData('title')}}</h2>
            </div>
            <div class="col-sm-12 text-center pt-1">
              <h5>{{hearingData('subtitle')}}</h5>
            </div>
            <div class="col-sm-12 text-center pt-1 white-space-pre-wrap" v-html="getHearingBody()"></div>
          </div>
        </div>
      </BOverlay>
    </CustomerMeetingLayout>
    <CommonModal ref="commonModal" modal-id="common-modal" />
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import CustomerMeetingLayout from '@/layout/CustomerMeetingLayout'
import CommonModal from '@/components/CommonModal'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
import cstore from '@/store/customer-store'
import mstore from '@/store/meeting-store'

export default {
  name: 'CustomerMeetingHearing',
  components: { CommonLayout, CustomerMeetingLayout, CommonModal },
  data () {
    return {
      overlayShow: false,
      signalingData: [],
      customerDisplayFlag: cstore.getters.customerDisplayFlag === null ? false : cstore.getters.customerDisplayFlag,
      isSendFirstSignalingData: false
    }
  },
  computed: {
    getIsTargetAtendeeActive () {
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return cstore.getters.signalingReceiveData
    }
  },
  watch: {
    getIsTargetAtendeeActive (newData, oldData) {
      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        if (sessionStorage.getItem('lastRoutePath') === this.$route.path) {
          SignalingModel.sendAgainEvent()
        }
        this.isSendFirstSignalingData = true
      }
    },

    getSignalingData (newData, oldData) {
      try {
        const payload = { ...(newData || {}) }
        payload.user = 'customer'
        payload.timestampMs = Date.now()

        CommonLogModel.apiSetStore(this.getModal(), payload, () => {})

        if (newData['id'] === 'reDrawMemoImage') {
          const tableRowId = ('tableRowId' in newData && newData['tableRowId']) ? newData['tableRowId'] : ''
          const targetPath = '/customer/meeting/product_selection/' + newData['projectNumber']
          localStorage.currentProjectType = newData['projectType']
          localStorage.suggestionType = newData['suggestionType']
          this.$router.push({ path: targetPath, query: { projectType: newData['projectType'], tableRowId } })
        } else if (newData['id'] === 'operationInvalid') {
          cstore.commit('setIsOperationPossible', false)
        }

        if (newData['id'] !== 'reDrawMemoImage' && newData['current_path'] && oldData) {
          const synchPass = newData['current_path'].replace('florist', 'customer')
          if (synchPass !== this.$route.path) {
            return this.$router.push(synchPass)
          }
        }

        if (newData['event'] === 'click' && (newData['id'] === 'next' || newData['id'] === 'back')) {
          this.$router.push(newData['target_path'])
        }

        if (newData['event'] === 'click') {
          if (newData['id'] === 'priceHide') {
            cstore.commit('setCustomerDisplayFlag', false)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          } else if (newData['id'] === 'priceDisplay') {
            cstore.commit('setCustomerDisplayFlag', true)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          } else if (newData['id'] === 'productDetailFromBookmark') {
            localStorage.currentProjectType = newData['projectType']
            localStorage.suggestionType = newData['suggestionType']
            const targetPath = '/customer/meeting/product_selection/' + newData['projectNumber']
            this.$router.push({path: targetPath, query: {'projectType': newData['projectType'], 'suggestionType': newData['suggestionType'], 'fromBookmark': true}})
          }
        }

        if (newData['event'] === 'api') {
          this.signalingData = newData.data.contents
          localStorage.currentProjectType = newData.data.project_type
          localStorage.suggestionType = newData.data.suggestion_type
        }
      } catch (err) {
        CommonLogModel.apiSetStore(
          this.getModal(),
          { timestampMs: Date.now(), errorMessage: err.message },
          () => {}
        )
      }
    }
  },
  methods: {
    getModal () {
      return this.$refs?.commonModal ?? null
    },
    hearingData (key) {
      return this.signalingData[key]
    },
    getHearingBody () {
      let body = this.signalingData['body']
      if (body) {
        body = body.replace('{会社名}', this.signalingData['companyName'])
        body = body.replace(/\\n/g, '<br/>')
      }
      return body
    }
  }
}
</script>
